// extracted by mini-css-extract-plugin
export default {"--primary-black":"var(--primary-black)","--dark-grey":"var(--dark-grey)","--lighter-grey":"var(--lighter-grey)","--text-color":"var(--text-color)","--gold":"var(--gold)"};